<template>
  <div class="content_box">
    <!-- <div style=" font-size: 16px;">银行卡绑定</div> -->
    <div style="display: flex;justify-content: center;">
      <div class="step_box clearfix">
        <div class="f_l" style="width:35%">
          <div class="step_item">
            <div class="f_l">
              <div class="step_round"><i class="el-icon-check"></i></div>
              <div class="step_title" style="color: rgba(0,0,0,0.65);">填写账户信息</div>
            </div>
            <div style="flex:1">
              <div class="step_line"></div>
            </div>
          </div>
        </div>
        <div class="f_l" style="width:35%">
          <div class="step_item">
            <div class="f_l step_ing">
              <div class="step_round">2</div>
              <div class="step_title">激活账户</div>
            </div>
            <div style="flex:1">
              <div class="step_line"></div>
            </div>
          </div>
        </div>
        <div class="f_l" style="width:20%">
          <div class="step_item">
            <div class="f_l">
              <div class="step_round">3</div>
              <div class="step_title">完成</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;width:89%">
      <div class="note_box" v-show="showBox">
        <div style="display:flex">
          <div style="color:#FFE58F;margin-right:16px;font-size: 24px;margin-top:-2px" class="f_l">
            <i class="el-icon-warning-outline"></i>
          </div>
          <div style="flex:1">
             <div style="font-size: 16px;color: rgba(0,0,0,0.85);line-height:24px">请注意!</div>
             <div style="font-size: 14px;color: rgba(0,0,0,0.65);line-height: 22px;">
               顺丰运力将往贵司银行账户转入一笔金额进行账户验证。收到转入金额信息后请在下方输入转入的金额。
             </div>
          </div>
        </div>
        <div class="closed" @click="showBox = false">x</div>
      </div>
    </div>
    <div style="display: flex;justify-content: center;width:82%">
      <div class="from_box">
      <el-form ref="activeform" :model="formMsg" :rules="rules" label-width="120px">
        <el-form-item label="收款金额：" prop="money" style="margin-bottom:20px">
          <el-input placeholder="请输入收款金额" v-model="formMsg.money"  clearable class="input-with-select" style="width:410px">
            <template slot="prepend"></template>
          </el-input>
        </el-form-item>
        <el-form-item id="active-btn-wrapper">
         <el-button :disabled="btnDisabled"  @click="onSubmit('activeform')">激活</el-button>
         <span class="reactive-text" @click="recheck">未收到打款？重新验证</span>
      </el-form-item>
      </el-form>  
    </div>
    </div>
  </div>
</template>

<script>
import fetchPost from "@/api/http.js";
import { fetchResPsot } from "@/api/http.js";

export default {
  props:["bankCard", "bankCardId"],
  data() {
    var checkMoney = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('收款金额不能为空'));
        }
        if (isNaN(value)) {
            callback(new Error('请输入数字值'));
          } else {
               var newArr =  value.split(".")
            if (parseFloat(value) <0 || parseFloat(value) >999999) {
              callback(new Error('收款金额范围为0-999999'));
            } else if(newArr[1] && newArr[1].length>=3){
              callback(new Error('收款金额政保留两位小数'));
            }else {
              callback();
            }
          }
      };
    return {
      formMsg: {
        money:""
      },
      rules: {
        money:{required: true,validator: checkMoney, trigger: 'blur' }
      },
      showBox: true,
      btnDisabled: false
    };
  },
  methods:{
    onSubmit(formName){
      this.btnDisabled = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.transferCheck()
        } else {
          this.btnDisabled = false
          console.log('error submit!!');
          return false;
        }
      });
    },
    recheck () {
      if (this.disabled) {
        return 
      }
      const data = {
        bankCard: this.bankCard,
        noFailMsg: true
      }
      this.disabled = true
      fetchResPsot("/saas/bankAccountBind/queryAuthenticationResult", data).then((res) => {
        this.disabled = false
        if (res && res.succ === 'ok') {
          this.$alert('小额打款成功，请登录网银查看小额打款金额', {
            title: '提示',
            confirmButtonText: '知道了'
          })
        } else {
          this.$alert(res.msg, {
            title: '提示',
            confirmButtonText: '重新修改账户信息',
            callback: action => {
              if (action === 'confirm') {
                // sessionStorage.setItem('bankCard', '')
                this.formMsg.money = ''
                this.$emit('edit-account')
              }
            }
          })
        }
      });
    },
    transferCheck(){
      var data = {
        id:this.bankCardId,
        authAmount:parseFloat(this.formMsg.money) 
      }
      fetchPost("/saas/bankAccountBind/v2/transferCheck", data).then(res => {
        this.btnDisabled = false
        if(res){
          this.$parent.$emit('removePage', '/manage/AddCard')
           //console.log(res)
          //  this.$emit("getAccountId",res.id)
           //sessionStorage.setItem('accountId', res.id)
           //this.$router.push("/manage/Complete");
        }
      }).catch(() => {
        this.btnDisabled = false
      })
    }
  }
};
</script>

<style lang="less">
#active-btn-wrapper {
  .el-form-item__content {
    width: 100%;
    .reactive-text {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less" scoped>
.f_l {
  float: left;
}
.from_box{
  width: 480px;
  margin-bottom: 90px !important;
  margin-top: 32px !important;
}
.from_box .el-button{
  background: #DC1E32;
  color: #fff;
}
.note_box{
  position: relative;
  width: 616px;
  height: 104px;
  background: #FFFBE6;
  border: 1px solid #FFE58F;
  border-radius: 4px;
  padding: 16px 24px !important;
  box-sizing: border-box;
  .closed{
    position: absolute;
    right: 20px;
    top:8px;
    font-size: 14px;
    color:rgba(0,0,0,0.45);
    cursor: pointer;
  }
}
.content_box {
  color: #000;
  padding: 24px 32px !important;
  font-family: PingFangSC-Medium;
  .step_box {
    width: 800px;
    margin-top: 30px !important;
    margin-bottom: 45px !important;
    .step_item {
      width: 100%;
      display: flex;
      .step_round {
        float: left;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-right: 8px !important;
        border-radius: 50%;
      }
      .step_title {
        float: left;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.45);
        line-height: 32px;
      }
      .step_line {
        margin: 0 8px !important;
        margin-top: 15px !important;
        height: 1px;
        background: rgba(0, 0, 0, 0.15);
      }
      .step_ing {
        .step_round {
          background: #f6c7cc;
          color: #dc1e32;
          border: none;
        }
        .step_title {
          color: #000;
        }
      }
    }
  }
}
.tips_box {
    padding-top: 24px !important;
    border-top: 1px solid #E9E9E9;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
  }
</style>